module.exports = __webpack_public_path__ + "img/ead729a.png";